import React, { createContext, useContext } from 'react'
import { useQuery } from '@apollo/client'
import Loading from '../components/Loading'
import { COUNTRIES } from '../graphql/expert'
import {
  getBalance,
  getActiveProjects,
  getPendingProjects,
  getPastProjects,
} from '../utils/helpers'
import UserContext from './UserContext'

const DataContext = createContext({ advisor: null })
export const DataProvider = ({ children }) => {
  const { user } = useContext(UserContext)
  const { loading, data } = useQuery(COUNTRIES, {
    context: { fatalError: true },
  })

  if (loading) return <Loading />

  return (
    <DataContext.Provider
      value={{
        countries: data?.countries || [],
        advisor: user,
        balance: getBalance(user.jobs),
        activeProjects: getActiveProjects(user.jobs),
        pendingProjects: getPendingProjects(user.jobs),
        pastProjects: getPastProjects(user.jobs),
      }}
    >
      {children}
    </DataContext.Provider>
  )
}

export default DataContext
